<template>
  <div class="info-section">
    <v-icon :color="count ? 'pink' : 'lime'">mdi-information</v-icon>
    <template v-if="count">
      <p>
        {{
          $t("message.externalChanges.changesInfoSection.detectedChanges", {
            changesCount: changesCountLabel,
            facilitiesCount: facilitiesCountLabel
          })
        }}<br />
        {{
          $t("message.externalChanges.changesInfoSection.changesRelatedTo", {
            fields: fieldsLabel
          })
        }}
      </p>
      <p>
        <i18n
          path="message.externalChanges.changesInfoSection.availableHere"
          tag="span"
        >
          <template v-slot:link>
            <router-link :to="{ name: 'external-changes-list' }">{{
              $t("message.externalChanges.changesInfoSection.here")
            }}</router-link>
          </template>
        </i18n>
      </p>
      <p>
        {{ $t("message.externalChanges.changesInfoSection.confirmReject") }}
      </p>
      <ui-button
        :loading="rejectInProgress"
        outlined
        color="primary"
        @click="confirmRejection()"
        >{{
          $t("message.externalChanges.changesInfoSection.rejectDetectedChanges")
        }}</ui-button
      >
    </template>
    <p v-else class="mb-0">
      {{ $t("message.externalChanges.changesInfoSection.noChanges") }}
    </p>
  </div>
</template>

<script>
import externalChangesSummary from "@/helpers/mixins/external-changes-summary";
import { isUtmTaggedUrl } from "@/helpers/utm-tags";

export default {
  name: "ExternalChangesInfoSection",
  mixins: [externalChangesSummary],
  methods: {
    clearQueryParams() {
      this.$router.replace({ query: {} });
    }
  },
  created() {
    this.fetchProtectionSummary();
  },
  mounted() {
    if (
      isUtmTaggedUrl(this.$route.query) &&
      this.$route.query.utm_content === "ext-changes-protection-reject"
    ) {
      this.rejectAndConfirm(this.clearQueryParams);
    }
  }
};
</script>

<style lang="scss" scoped>
.info-section {
  position: relative;
  padding: $spacing * 1.5 $spacing * 5;
  margin: $spacing * 4 0 $spacing * 2;
  background: $base-light;
  border-radius: 8px;

  .v-icon {
    position: absolute;
    left: 10px;
    top: 10px;
  }
}
</style>
